import { PictureDesktopNames, PictureTransformations } from 'common/components';

export const PRODUCT_MEDIA_TRANSFORMATIONS: PictureTransformations = {
  [PictureDesktopNames.ImgLargeDesk]: {
    width: 586,
    height: 586,
    objectFit: 'fit',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgDesk]: {
    width: 440,
    height: 440,
    objectFit: 'fit',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgTablet]: {
    width: 600,
    height: 600,
    objectFit: 'fit',
    dpr: '2.0',
  },
  [PictureDesktopNames.ImgMobile]: {
    width: 288,
    height: 288,
    objectFit: 'fit',
    dpr: '2.0',
  },
};
